export const clearFilterByType = (filters, type) => ({ ...filters, [type]: [] });

export const toggleFilterValue = (filters, { type, value }) => {
  const current = filters[type];

  const updated = current.includes(value)
    ? current.filter((existingValue) => existingValue !== value)
    : [...current, value];

  return { ...filters, [type]: updated };
};
